export const Logo = ({ dark = false, className }) => (
  <img
    src={dark ? "/brand/logo-dark.png" : "/brand/logo-light.png"}
    alt="Wilson Courier Solutions — Delivering Excellence"
    data-testid="wcs-logo"
    className={className || "h-10 w-auto lg:h-12"}
  />
);
